import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-select-advertisement-type',
  templateUrl: './select-advertisement-type.component.html',
  styleUrls: ['./select-advertisement-type.component.scss']
})
export class SelectAdvertisementTypeComponent implements OnInit {
  @Input() userId:string;
  @Input() publicAdsAllowed:boolean;
  @Input() materialAdsAllowed:boolean;

  constructor(
    private activeModal: NgbActiveModal,
    private _router: Router
    ) { }

  ngOnInit() {
    // console.log(this.materialAdsAllowed)
  }

  selectMaterial(){
    if(this.materialAdsAllowed){
      this._router.navigate(['/advertisement'], { queryParams: { userId: this.userId,advertise_on:'material'} });
      this.activeModal.close();
    }
  }

  selectSpace(){
    if(this.publicAdsAllowed){
      this.activeModal.close('public_profile');
    }
  }

  closeDialog() {
    this.activeModal.close();
  }

}
